require('dotenv').config()
import 'core-js/full'
import storage from 'local-storage-fallback'
import App from 'modules/App'
import React from 'react'
import ReactDOM from 'react-dom'
import 'regenerator-runtime/runtime'
import 'global.scss'
import * as Sentry from '@sentry/browser'

if (!('localStorage' in window)) {
  global.localStorage = storage
}

console.logXHR = console.error

if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/frontend/react-app/sw.js', {
        scope: '/',
      })
    })
  }

  Sentry.init({
    dsn: process.env?.REACT_APP_SENTRY_DSN ?? '',
    tunnel: '/communication',
    integrations: [
      // Add browser profiling integration to the list of integrations
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.globalHandlersIntegration({
        onerror: true,
        onunhandledrejection: false,
      }),
      Sentry.replayIntegration(),
      Sentry.replayCanvasIntegration(),
    ],
    tracesSampleRate: 1.0,
    release: global.SENTRY_RELEASE.id,
  })

  // TODO: add sentry logging maybe?
  console.logXHR = () => {}
}

ReactDOM.render(<App />, document.getElementById('app-root'))
